import { useCallback } from "react";

import { queryKeys } from "~/v2/api/queryKeys";
import { positionsQueryKeys } from "~/v3-poc/api/positions";
import { useInvalidate } from "~/v3-poc/kernel/react/Invalidation.context";

export const useInvalidateOrderRelatedQueries = () => {
  const invalidate = useInvalidate();

  return useCallback(() => {
    invalidate({ queryKey: queryKeys.orders.all });
    invalidate({ queryKey: queryKeys.positions.all });
    invalidate({ queryKey: positionsQueryKeys.all });
  }, [invalidate]);
};
